import { Button } from "@/components/ui/button";
import MissoesCaatingaMasonryGallery from "@/components/sections/MissoesCaatingaMasonryGallery";
import teologiaLogo from "@/assets/teologia-logo.png";
import teologiaRegistro1 from "@/assets/teologia-registro-1.jpg";
import teologiaRegistro2 from "@/assets/teologia-registro-2.jpg";
import teologiaRegistro5 from "@/assets/teologia-registro-5.jpg";
import teologiaRegistro6 from "@/assets/teologia-registro-6.jpg";
import { Link } from "react-router-dom";

const Teologia = () => {
  const galleryItems = [
    {
      id: "teo-1",
      img: teologiaRegistro1,
      url: teologiaRegistro1,
      height: 880,
      alt: "Registro do curso de teologia - aula e comunhão (foto 1)",
    },
    {
      id: "teo-2",
      img: teologiaRegistro2,
      url: teologiaRegistro2,
      height: 760,
      alt: "Registro do curso de teologia - momento de aprendizado (foto 2)",
    },
    {
      id: "teo-3",
      img: teologiaRegistro5,
      url: teologiaRegistro5,
      height: 820,
      alt: "Registro do curso de teologia - momento de estudo e oração (foto 3)",
    },
    {
      id: "teo-4",
      img: teologiaRegistro6,
      url: teologiaRegistro6,
      height: 640,
      alt: "Registro do curso de teologia - turma reunida em sala (foto 4)",
    },
  ];

  return (
    <section className="section-shell">
      <header className="mb-10 grid gap-6 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:items-center">
        <div className="space-y-3 max-w-3xl">
          <p className="section-title">Curso de Teologia</p>
          <h1 className="section-heading">Formação bíblica com coração pastoral.</h1>
          <p className="section-subtitle">
            O curso de Teologia do Instituto foi pensado para quem deseja aprofundar-se nas Escrituras e servir melhor à
            igreja local, unindo conteúdo sólido, prática ministerial e vida devocional.
          </p>
        </div>

        <div className="flex items-center justify-center">
          <div className="relative flex items-center justify-center rounded-3xl bg-primary/5 px-6 py-5 shadow-inner md:px-8 md:py-7">
            <img
              src={teologiaLogo}
              alt="Logotipo do curso de Teologia"
              className="max-h-32 w-auto object-contain md:max-h-40"
              loading="lazy"
              width={160}
              height={160}
            />
          </div>
        </div>
      </header>

      <div className="grid gap-10 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:items-start">
        <article className="space-y-4">
          <h2 className="text-2xl font-semibold">Diferenciais do curso.</h2>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li>• Ênfase na exposição bíblica e na aplicação pastoral.</li>
            <li>• Professores com experiência em igreja local e campo missionário.</li>
            <li>• Ambiente espiritual de oração, cuidado e comunhão.</li>
            <li>• Conteúdos acessíveis para diferentes níveis de escolaridade.</li>
          </ul>

          <div className="grid gap-4 md:grid-cols-3">
            <InfoPill title="Teologia Bíblica" subtitle="Livros, temas e narrativa das Escrituras." />
            <InfoPill title="Teologia Prática" subtitle="Vida da igreja, cuidado e missão urbana e rural." />
            <InfoPill title="Vida Devocional" subtitle="Formação do coração do servo de Deus." />
          </div>
        </article>

        <aside className="card-ambient p-6 space-y-4">
          <h2 className="text-lg font-semibold">Acesso acadêmico</h2>
          <p className="text-sm text-muted-foreground">
            Enquanto os sistemas acadêmicos não são integrados ao site, utilize os botões abaixo como referência de
            acesso. Todos os links estão configurados apenas como exemplo (placeholders).
          </p>

          <div className="space-y-3">
            <Button asChild className="w-full btn-pill-lg">
              <a href="https://iessa.vercel.app/BoletinsIESSA" target="_blank" rel="noreferrer">
                Acessar Notas
              </a>
            </Button>
            <Button asChild variant="outline" className="w-full btn-pill-lg border-primary/40 text-primary">
              <a href="https://iessa.vercel.app/CadastroAluno" target="_blank" rel="noreferrer">
                Fazer Matrícula
              </a>
            </Button>
            <Button asChild className="w-full btn-pill-lg">
              <Link to="/professores">Acesso para Professores</Link>
            </Button>
          </div>
        </aside>
      </div>

      <section className="mt-12 grid gap-8 md:grid-cols-2 md:items-center">
        <div className="card-ambient p-6">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-primary mb-3">Estrutura</p>
          <p className="text-sm text-muted-foreground">
            Aulas presenciais e/ou online (conforme a realidade do Instituto), com módulos sistemáticos, leituras
            dirigidas e acompanhamento próximo de mentores espirituais.
          </p>
        </div>
        <div className="space-y-3">
          <h2 className="text-xl font-semibold">Mais do que um curso, um caminho de formação.</h2>
          <p className="text-sm text-muted-foreground">
            Nosso desejo é ver homens e mulheres profundamente enraizados na Palavra, servindo com humildade, equilíbrio
            e amor nas diversas expressões da igreja evangélica.
          </p>
        </div>
      </section>

      <section className="mt-12 space-y-6">
        <header className="space-y-2">
          <h2 className="text-xl font-semibold">Confira alguns registros do nosso curso</h2>
        </header>
        <MissoesCaatingaMasonryGallery items={galleryItems} />
      </section>
    </section>
  );
};

interface InfoPillProps {
  title: string;
  subtitle: string;
}

const InfoPill = ({ title, subtitle }: InfoPillProps) => (
  <div className="card-ambient p-4">
    <p className="text-sm font-semibold text-foreground">{title}</p>
    <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>
  </div>
);

export default Teologia;
